import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Container, Row, Col, Badge, Tabs, Tab, Form, Button, Card, CardBody, Stack, Image, InputGroup } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useNavigationType, useParams } from "react-router-dom";
import Select, { StylesConfig } from "react-select";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import DataTableLayout from "layouts/DatatableLayout";
import { Formik, Field, FieldArray } from "formik";
import * as yup from "yup";
import Modal from "react-bootstrap/Modal";
import { nanoid } from "nanoid";
import DownloadExcel from "utils/DownloadExcel";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import RowExpansion from "layouts/RowExpansion";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { defaultOption } from "constants/ui/options";
import { getAllMstBusinessCategory } from "../../redux/handlers/master/getAllMstBusinessCategory.handler";
import { getAllMstPrefix } from "../../redux/handlers/master/getAllMstPrefix.handler";
import { getAllMstCompanyPrefix } from "../../redux/handlers/master/getAllMstCompanyPrefix.handler";
import { getAllMstBusinessType } from "../../redux/handlers/master/getAllMstBusinessType.handler";
import { getAllMstBank } from "../../redux/handlers/master/getAllMstBank.handler";
import { getAllMstBankAccountType } from "../../redux/handlers/master/getAllMstBankAccountType.handler";
import { getAllMstPaymentMethod } from "../../redux/handlers/master/getAllMstPaymentMethod.handler";
import { getAllMstPriceCategory } from "../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstPaymentType } from "../../redux/handlers/master/getAllMstPaymentType.handler";
import { getAllMstTypeDocument } from "../../redux/handlers/master/getAllMstTypeDocument.handler";
import { getAllProvince } from "../../redux/handlers/master/getAllProvince.handler";
import { getAllDistrict } from "../../redux/handlers/master/getAllDistrict.handler";
import { getAllDistrictSub } from "../../redux/handlers/master/getAllDistrictSub.handler";
import { getAllSubDistrict } from "../../redux/handlers/master/getAllSubDistrict.handler";
import { getAllSubDistrictSub } from "../../redux/handlers/master/getAllSubDistrictSub.handler";
import moment from "moment";
import "moment/locale/th";
import { base64ToBlob, getEmpFullNameTH, NumberFormatFloat, mapMstPrefixToOptions, mapMstToOptions, mapProvinceThToOptions, mapSubDistrictThToOptions, mapDistrictThToOptions } from "utils/HelperFunction";
import { getFullUrlPath } from "utils/HandleFileFunction";
import { mobilePhoneRegExp } from "utils/HelperRegex";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorIcon from "@mui/icons-material/Error";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Avatar } from "@mui/material";
import StackMui from "@mui/material/Stack";
import { red, deepOrange } from "@mui/material/colors";
import { productRowData, historyRowData } from "mocks/partnerData";
import { getPartnerInfoById, clearGetPartnerInfoById } from "../../redux/handlers/partner/getPartnerInfoById.handler";
import { getPartnerBankById, clearGetPartnerBankById } from "../../redux/handlers/partner/getPartnerBankById.handler";
import { getPartnerDocById, clearGetPartnerDocById } from "../../redux/handlers/partner/getPartnerDocById.handler";
import { getPartnerProductById, clearGetPartnerProductById } from "../../redux/handlers/partner/getPartnerProductById.handler";
import { getPartnerCommentById, clearGetPartnerCommentById } from "../../redux/handlers/partner/getPartnerCommentById.handler";
import { updateStatusPartner, clearUpdateStatusPartner } from "../../redux/handlers/partner/updateStatusPartner.handler";
import { createCommentPartner, clearCreateCommentPartner } from "../../redux/handlers/partner/createCommentPartner.handler";
import { updateStatusBankPartner, clearUpdateStatusBankPartner } from "../../redux/handlers/partner/updateStatusBankPartner.handler";
import { updateStatusDocPartner, clearUpdateStatusDocPartner } from "../../redux/handlers/partner/updateStatusDocPartner.handler";
import DownloadFile from "utils/DownloadFile";
export function ManagePartnerView() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(1), 2), tab = _useState[0], setTab = _useState[1];
    var _useState1 = _sliced_to_array(useState("view"), 2), mode = _useState1[0], setMode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), formdisabled = _useState2[0], setFormdisabled = _useState2[1];
    var partnerId = useParams().partnerId;
    var _useState3 = _sliced_to_array(useState(false), 2), redata = _useState3[0], setRedata = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), redataBank = _useState4[0], setRedataBank = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), redataDoc = _useState5[0], setRedataDoc = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), redataComment = _useState6[0], setRedataComment = _useState6[1];
    var _useState7 = _sliced_to_array(useState({}), 2), formdata = _useState7[0], setFormdata = _useState7[1];
    var getPartnerInfoByIdReducer = useAppSelector(function(state) {
        return state.getPartnerInfoByIdReducer;
    });
    var getData = function() {
        dispatch(getPartnerInfoById(parseInt(partnerId, 10), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState8 = _sliced_to_array(useState(false), 2), approveShow = _useState8[0], setApproveShow = _useState8[1];
    var _useState9 = _sliced_to_array(useState(false), 2), approveAlert = _useState9[0], setApproveAlert = _useState9[1];
    var handleApproveShow = function() {
        return setApproveShow(true);
    };
    var handleApproveClose = function() {
        return setApproveShow(false);
    };
    var handleApproveAlert = function() {
        return setApproveAlert(true);
    };
    var _useState10 = _sliced_to_array(useState(false), 2), sendEditShow = _useState10[0], setSendEditShow = _useState10[1];
    var _useState11 = _sliced_to_array(useState(false), 2), sendEditAlert = _useState11[0], setSendEditAlert = _useState11[1];
    var handleSendEditShow = function() {
        return setSendEditShow(true);
    };
    var handleSendEditClose = function() {
        return setSendEditShow(false);
    };
    var handleSendEditAlert = function() {
        return setSendEditAlert(true);
    };
    var _useState12 = _sliced_to_array(useState(false), 2), noApproveShow = _useState12[0], setNoApproveShow = _useState12[1];
    var _useState13 = _sliced_to_array(useState(false), 2), noApproveAlert = _useState13[0], setNoApproveAlert = _useState13[1];
    var handleNoApproveShow = function() {
        return setNoApproveShow(true);
    };
    var handleNoApproveClose = function() {
        return setNoApproveShow(false);
    };
    var handleNoApproveAlert = function() {
        return setNoApproveAlert(true);
    };
    var handleReLoadData = function() {
        return setRedata(true);
    };
    var handleBackPage = function() {
        return navigate("/manage_partner");
    };
    var handleReLoadDataBank = function() {
        setRedataBank(true);
        setRedataComment(true);
    };
    var handleReLoadDataDoc = function() {
        setRedataDoc(true);
        setRedataComment(true);
    };
    var _useState14 = _sliced_to_array(useState({
        idBank: 0,
        statusBank: 0,
        comment: ""
    }), 2), approveBank = _useState14[0], setApproveBank = _useState14[1];
    var _useState15 = _sliced_to_array(useState({
        idDoc: 0,
        statusDoc: 0,
        commentDoc: ""
    }), 2), dataStatusDoc = _useState15[0], setDataStatusDoc = _useState15[1];
    var _useState16 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState16[0], setModalsuccess = _useState16[1];
    var _useState17 = _sliced_to_array(useState(false), 2), approveBankShow = _useState17[0], setApproveBankShow = _useState17[1];
    var _useState18 = _sliced_to_array(useState(false), 2), sendEditBankShow = _useState18[0], setSendEditBankShow = _useState18[1];
    var _useState19 = _sliced_to_array(useState(false), 2), approveDocShow = _useState19[0], setApproveDocShow = _useState19[1];
    var _useState20 = _sliced_to_array(useState(false), 2), sendEditDocShow = _useState20[0], setSendEditDocShow = _useState20[1];
    useEffect(function() {
        setIsLoading(getPartnerInfoByIdReducer.isFetching);
        if (getPartnerInfoByIdReducer.data && !getPartnerInfoByIdReducer.isError) {
            var datas = getPartnerInfoByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            setFormdata(dataWithReplacements);
            setFormdisabled(true);
        }
    }, [
        getPartnerInfoByIdReducer
    ]);
    useEffect(function() {
        if (partnerId || redata) {
            getData();
            setRedata(false);
        }
    }, [
        partnerId,
        redata
    ]);
    // useEffect(() => {
    //     console.log('approveAlert : ',approveAlert);
    //     console.log('sendEditAlert : ',sendEditAlert);
    //     console.log('noApproveAlert : ',noApproveAlert);
    // }, [approveAlert,sendEditAlert,noApproveAlert]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/manage_partner",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ Partner"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ข้อมูลธุรกิจ",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card card-st-1",
                        children: /*#__PURE__*/ _jsx(Container, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                className: "justify-content-md-between",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        lg: 8,
                                        children: /*#__PURE__*/ _jsxs("p", {
                                            className: "h3 mt-3 mb-3",
                                            children: [
                                                formdata.bus_business_credate && formdata.bus_business_credate != null ? "สมัครเมื่อวันที่ ".concat(moment(formdata.bus_business_credate).format("DD/MM/YYYY"), " ") : "สมัครเมื่อวันที่ - ",
                                                "สถานะ ",
                                                /*#__PURE__*/ _jsx(StatusPartner, {
                                                    statusNo: formdata.bus_business_status
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex gap-2 mb-3 mt-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "success",
                                                    onClick: handleApproveShow,
                                                    children: "อนุมัติ"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "warning",
                                                    onClick: handleSendEditShow,
                                                    children: "ส่งกลับแก้ไข"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "danger",
                                                    onClick: handleNoApproveShow,
                                                    children: "ไม่อนุมัติ"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ _jsxs(Tabs, {
                            defaultActiveKey: "detail_partner",
                            id: "partner-tab-detail-com",
                            className: "mb-3 pills-st-1",
                            variant: "pills",
                            children: [
                                /*#__PURE__*/ _jsx(Tab, {
                                    eventKey: "detail_partner",
                                    title: "ข้อมูลธุรกิจ",
                                    children: /*#__PURE__*/ _jsx(PartnerDataView, {
                                        partnerData: formdata,
                                        setPartnerData: setFormdata,
                                        formDisabled: true,
                                        onBackPage: handleBackPage
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Tab, {
                                    eventKey: "contace_partner",
                                    title: "ข้อมูลผู้ติดต่อ",
                                    children: /*#__PURE__*/ _jsx(ContactPartnerView, {
                                        partnerData: formdata,
                                        setPartnerData: setFormdata,
                                        formDisabled: true,
                                        onBackPage: handleBackPage
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Tab, {
                                    eventKey: "social_partner",
                                    title: "ข้อมูล Social",
                                    children: /*#__PURE__*/ _jsx(SocialPartnerView, {
                                        partnerData: formdata,
                                        setPartnerData: setFormdata,
                                        formDisabled: true,
                                        onBackPage: handleBackPage
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Tab, {
                                    eventKey: "bank_partner",
                                    title: "ข้อมูลธนาคาร",
                                    children: /*#__PURE__*/ _jsx(BankPartnerView, {
                                        partnerData: formdata,
                                        setPartnerData: setFormdata,
                                        approveBank: approveBank,
                                        setApproveBank: setApproveBank,
                                        formDisabled: true,
                                        onBackPage: handleBackPage,
                                        approveBankModal: function() {
                                            return setApproveBankShow(true);
                                        },
                                        sendEditBankModal: function() {
                                            return setSendEditBankShow(true);
                                        },
                                        redata: redataBank,
                                        setRedata: setRedataBank
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Tab, {
                                    eventKey: "doc_partner",
                                    title: "เอกสาร",
                                    children: /*#__PURE__*/ _jsx(DocumentPartnerView, {
                                        partnerData: formdata,
                                        setPartnerData: setFormdata,
                                        dataStatusDoc: dataStatusDoc,
                                        setDataStatusDoc: setDataStatusDoc,
                                        formDisabled: true,
                                        onBackPage: handleBackPage,
                                        approveDocModal: function() {
                                            return setApproveDocShow(true);
                                        },
                                        sendEditDocModal: function() {
                                            return setSendEditDocShow(true);
                                        },
                                        redata: redataDoc,
                                        setRedata: setRedataDoc
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Tab, {
                                    eventKey: "product_partner",
                                    title: "ข้อมูลสินค้า",
                                    children: /*#__PURE__*/ _jsx(ProductDetailView, {
                                        partnerData: formdata,
                                        setPartnerData: setFormdata,
                                        onBackPage: handleBackPage
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(CommentPartnerView, {
                        partnerData: formdata,
                        setPartnerData: setFormdata,
                        formDisabled: true,
                        onBackPage: handleBackPage,
                        redata: redataComment,
                        setRedata: setRedataComment
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ApproveModal, {
                show: approveShow,
                onHide: handleApproveClose,
                setPartnerData: setFormdata,
                partnerData: formdata,
                redata: handleReLoadData,
                onAlert: handleApproveAlert
            }),
            /*#__PURE__*/ _jsx(SendEditModal, {
                show: sendEditShow,
                onHide: handleSendEditClose,
                setPartnerData: setFormdata,
                partnerData: formdata,
                redata: handleReLoadData,
                onAlert: handleSendEditAlert
            }),
            /*#__PURE__*/ _jsx(NoApproveModal, {
                show: noApproveShow,
                onHide: handleNoApproveClose,
                setPartnerData: setFormdata,
                partnerData: formdata,
                redata: handleReLoadData,
                onAlert: handleNoApproveAlert
            }),
            /*#__PURE__*/ _jsx(ApproveBankModal, {
                show: approveBankShow,
                onHide: function() {
                    return setApproveBankShow(false);
                },
                approveBank: approveBank,
                setApproveBank: setApproveBank,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                redata: handleReLoadDataBank
            }),
            /*#__PURE__*/ _jsx(SendEditBankModal, {
                show: sendEditBankShow,
                onHide: function() {
                    return setSendEditBankShow(false);
                },
                sendEditBank: approveBank,
                setSendEditBank: setApproveBank,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                redata: handleReLoadDataBank
            }),
            /*#__PURE__*/ _jsx(ApproveDocModal, {
                show: approveDocShow,
                onHide: function() {
                    return setApproveDocShow(false);
                },
                approveDoc: dataStatusDoc,
                setApproveDoc: setDataStatusDoc,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                redata: handleReLoadDataDoc
            }),
            /*#__PURE__*/ _jsx(SendEditDocModal, {
                show: sendEditDocShow,
                onHide: function() {
                    return setSendEditDocShow(false);
                },
                sendEditDoc: dataStatusDoc,
                setSendEditDoc: setDataStatusDoc,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                redata: handleReLoadDataDoc
            }),
            approveAlert && !sendEditAlert && !noApproveAlert ? /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: approveAlert,
                onHide: function() {
                    return setApproveAlert(false);
                },
                textsuccess: "อนุมัติเรียบร้อย",
                navigate: navigate,
                direction: ""
            }) : sendEditAlert && !approveAlert && !noApproveAlert ? /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: sendEditAlert,
                onHide: function() {
                    return setSendEditAlert(false);
                },
                textsuccess: "ส่งกลับไปให้แก้ไขเรียบร้อย",
                navigate: navigate,
                direction: ""
            }) : noApproveAlert && !approveAlert && !sendEditAlert ? /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: noApproveAlert,
                onHide: function() {
                    return setNoApproveAlert(false);
                },
                textsuccess: "ไม่อนุมัติเรียบร้อย",
                navigate: navigate,
                direction: ""
            }) : modalsuccess && modalsuccess.visible ? /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            }) : /*#__PURE__*/ _jsx(_Fragment, {})
        ]
    });
}
// function view tab
function PartnerDataView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var partnerId = useParams().partnerId;
    var onBackPage = props.onBackPage, formDisabled = props.formDisabled;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState(false), 2), imgData = _useState[0], setImgData = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), modalShow = _useState1[0], setModalShow = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), provinceId = _useState2[0], setProvinceId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), districtId = _useState3[0], setDistrictId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), provinceIdSub = _useState4[0], setProvinceIdSub = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), districtIdSub = _useState5[0], setDistrictIdSub = _useState5[1];
    var loadAllMsts = function() {
        dispatch(getAllMstBusinessType());
        dispatch(getAllMstPrefix());
        dispatch(getAllMstCompanyPrefix());
        dispatch(getAllProvince());
        dispatch(getAllMstBusinessCategory());
    };
    var _useState6 = _sliced_to_array(useState([]), 2), optionsMstPrefix = _useState6[0], setOptionsMstPrefix = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionsMstCompanyPrefix = _useState7[0], setOptionsMstCompanyPrefix = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionsProvince = _useState8[0], setOptionsProvince = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionsDistrict = _useState9[0], setOptionsDistrict = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionsDistrictSub = _useState10[0], setOptionsDistrictSub = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), optionsSubDistrict = _useState11[0], setOptionsSubDistrict = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsSubDistrictSub = _useState12[0], setOptionsSubDistrictSub = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionsMstBusinessCategory = _useState13[0], setOptionsMstBusinessCategory = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), optionsBusinessTypes = _useState14[0], setOptionsBusinessTypes = _useState14[1];
    var getAllMstPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstPrefixReducer;
    });
    var getAllMstCompanyPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstCompanyPrefixReducer;
    });
    var getAllProvinceReducer = useAppSelector(function(state) {
        return state.getAllProvinceReducer;
    });
    var getAllDistrictReducer = useAppSelector(function(state) {
        return state.getAllDistrictReducer;
    });
    var getAllDistrictSubReducer = useAppSelector(function(state) {
        return state.getAllDistrictSubReducer;
    });
    var getAllSubDistrictReducer = useAppSelector(function(state) {
        return state.getAllSubDistrictReducer;
    });
    var getAllSubDistrictSubReducer = useAppSelector(function(state) {
        return state.getAllSubDistrictSubReducer;
    });
    var getAllMstBusinessCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessCategoryReducer;
    });
    var getAllMstBusinessTypeReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessTypeReducer;
    });
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        dispatch(getAllDistrict({
            provinceid: parseInt(provinceId, 10)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllSubDistrict({
            provinceid: parseInt(provinceId, 10),
            districtid: parseInt(districtId, 10)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllDistrictSub({
            provinceid: parseInt(provinceIdSub, 10)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllSubDistrictSub({
            provinceid: parseInt(provinceIdSub, 10),
            districtid: parseInt(districtIdSub, 10)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        provinceId,
        districtId,
        provinceIdSub,
        districtIdSub
    ]);
    useEffect(function() {
        setIsLoading(getAllMstPrefixReducer.isFetching || getAllMstCompanyPrefixReducer.isFetching || getAllMstBusinessCategoryReducer.isFetching || getAllMstBusinessTypeReducer.isFetching || getAllProvinceReducer.isFetching || getAllDistrictReducer.isFetching || getAllDistrictSubReducer.isFetching || getAllSubDistrictReducer.isFetching || getAllSubDistrictSubReducer.isFetching);
        if (getAllMstPrefixReducer.data) {
            var options = mapMstToOptions(getAllMstPrefixReducer.data.data);
            setOptionsMstPrefix(_to_consumable_array(options));
        }
        if (getAllMstCompanyPrefixReducer.data) {
            var options1 = mapMstPrefixToOptions(getAllMstCompanyPrefixReducer.data.data);
            setOptionsMstCompanyPrefix(_to_consumable_array(options1));
        }
        if (getAllProvinceReducer.data) {
            var options2 = mapProvinceThToOptions(getAllProvinceReducer.data.data);
            setOptionsProvince(_to_consumable_array(options2));
        }
        if (getAllDistrictReducer.data) {
            var options3 = mapDistrictThToOptions(getAllDistrictReducer.data.data);
            setOptionsDistrict(_to_consumable_array(options3));
        }
        if (getAllSubDistrictReducer.data) {
            var options4 = mapSubDistrictThToOptions(getAllSubDistrictReducer.data.data);
            setOptionsSubDistrict(_to_consumable_array(options4));
        }
        if (getAllDistrictSubReducer.data) {
            var options5 = mapDistrictThToOptions(getAllDistrictSubReducer.data.data);
            setOptionsDistrictSub(_to_consumable_array(options5));
        }
        if (getAllSubDistrictSubReducer.data) {
            var options6 = mapSubDistrictThToOptions(getAllSubDistrictSubReducer.data.data);
            setOptionsSubDistrictSub(_to_consumable_array(options6));
        }
        if (getAllMstBusinessCategoryReducer.data) {
            var options7 = mapMstToOptions(getAllMstBusinessCategoryReducer.data.data);
            setOptionsMstBusinessCategory(_to_consumable_array(options7));
        }
        if (getAllMstBusinessTypeReducer.data) {
            getAllMstBusinessTypeReducer.data.data.map(function(item, index) {
                if (item.id && item.id != "" && item.id > 0) {
                    setOptionsBusinessTypes(function(optionsBusinessTypes) {
                        return _to_consumable_array(optionsBusinessTypes).concat([
                            {
                                label: item.name,
                                value: item.id
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        getAllMstCompanyPrefixReducer,
        getAllMstPrefixReducer,
        getAllProvinceReducer,
        getAllDistrictReducer,
        getAllDistrictSubReducer,
        getAllSubDistrictReducer,
        getAllSubDistrictSubReducer,
        getAllMstBusinessCategoryReducer
    ]);
    useEffect(function() {
        if (partnerId) {
            setProvinceId(partnerData.bus_business_provinceid);
            setDistrictId(partnerData.bus_business_subprovinceid);
            setProvinceIdSub(partnerData.bus_business_docprovinceid);
            setDistrictIdSub(partnerData.bus_business_docsubprovinceid);
        }
    }, [
        partnerData
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-1 mb-4",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ _jsx(Form, {
                    children: /*#__PURE__*/ _jsxs("fieldset", {
                        disabled: formDisabled,
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "fs-20 fw-bold tc-5 mb-2",
                                            children: "ข้อมูลกิจการ"
                                        })
                                    }),
                                    partnerData.bus_business_status == 5 ? /*#__PURE__*/ _jsx(Col, {
                                        className: "text-end mb-2",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "px-3 py-2 text-center badge fs-16",
                                            style: {
                                                color: "rgba(211, 47, 47, 1)",
                                                backgroundColor: "rgba(253, 237, 237, 1)",
                                                borderRadius: "20px"
                                            },
                                            children: "ไม่อนุมัติ เมื่อวันที่ " + (partnerData.bus_business_updatedate ? moment(partnerData.bus_business_updatedate).format("DD/MM/YYYY") : "-")
                                        })
                                    }) : partnerData.bus_business_status == 3 ? /*#__PURE__*/ _jsx(Col, {
                                        className: "text-end mb-2",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "px-3 py-2 text-center badge fs-16",
                                            style: {
                                                color: "rgba(114, 225, 40, 0.87)",
                                                backgroundColor: "rgba(238, 251, 229, 1)",
                                                borderRadius: "20px"
                                            },
                                            children: "อนุมัติแล้ว เมื่อวันที่ " + (partnerData.bus_business_approvaldate ? moment(partnerData.bus_business_approvaldate).format("DD/MM/YYYY") : "-")
                                        })
                                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "d-flex align-items-center mb-4 mt-3 ",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "bx-upload",
                                    children: partnerData.bus_business_profile && partnerData.bus_business_profile != "" && partnerData.bus_business_profile != null ? /*#__PURE__*/ _jsx("img", {
                                        src: partnerData.bus_business_profile
                                    }) : /*#__PURE__*/ _jsx("div", {
                                        className: "preimg"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                    inline: true,
                                                    type: "radio",
                                                    id: "p-radio-1",
                                                    label: "บุคคลธรรมดา",
                                                    checked: partnerData.bus_business_businesstype == 1 ? true : false,
                                                    className: "form-check-st-2 tc-7 mt-0",
                                                    name: "business_type_id",
                                                    onChange: function() {}
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Check // prettier-ignore
                                                , {
                                                    inline: true,
                                                    type: "radio",
                                                    id: "p-radio-2",
                                                    label: "นิติบุคคล",
                                                    checked: partnerData.bus_business_businesstype == 2 ? true : false,
                                                    className: "form-check-st-2 tc-7 mt-0",
                                                    name: "business_type_id",
                                                    onChange: function() {}
                                                })
                                            ]
                                        }, "p-radio")
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "VENDOR CODE"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "code_vendor",
                                                    placeholder: "VENDOR CODE",
                                                    value: partnerData.bus_business_vendorcode != null && partnerData.bus_business_vendorcode != "" ? partnerData.bus_business_vendorcode : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 7,
                                        md: 7,
                                        lg: 5,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลขที่ประจำตัวผู้เสียภาษี"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "tax_code",
                                                    placeholder: "เลขที่ประจำตัวผู้เสียภาษี",
                                                    value: partnerData.bus_business_taxid != null && partnerData.bus_business_taxid != "" ? partnerData.bus_business_taxid : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    partnerData.bus_business_businesstype == 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 8,
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    children: optionsMstBusinessCategory.map(function(c, idx) {
                                                        return /*#__PURE__*/ _jsx(Form.Check, {
                                                            inline: true,
                                                            type: "radio",
                                                            id: "bn-radio-".concat(c.value),
                                                            label: c.label,
                                                            checked: partnerData.bus_business_categoryid == c.value ? true : false,
                                                            className: "form-check-st-2 tc-7 mt-0",
                                                            name: "bus_business_categoryid",
                                                            onChange: function() {}
                                                        });
                                                    })
                                                }, "bn-radio")
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ประเภท"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Form.Select, {
                                                            name: "bus_business_comprefixid",
                                                            className: "w-100 select-st-1",
                                                            disabled: formDisabled,
                                                            onChange: function(e) {
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    bus_business_comprefixid: e.value
                                                                }));
                                                            },
                                                            value: partnerData.bus_business_comprefixid,
                                                            children: [
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "",
                                                                    children: "เลือกประเภท"
                                                                }),
                                                                optionsMstCompanyPrefix.map(function(value, index) {
                                                                    return /*#__PURE__*/ _jsx("option", {
                                                                        value: value.value,
                                                                        children: value.label
                                                                    }, index);
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "คำนำหน้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_comprefixname",
                                                            placeholder: "กรอกคำนำหน้า",
                                                            value: partnerData.bus_business_comprefixname != null && partnerData.bus_business_comprefixname != "" ? partnerData.bus_business_comprefixname : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ชื่อธุระกิจ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_name",
                                                            placeholder: "กรอกชื่อธุระกิจ",
                                                            value: partnerData.bus_business_name != null && partnerData.bus_business_name != "" ? partnerData.bus_business_name : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "คำลงท้าย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_suffixname",
                                                            placeholder: "กรอกคำลงท้าย",
                                                            value: partnerData.bus_business_suffixname != null && partnerData.bus_business_suffixname != "" ? partnerData.bus_business_suffixname : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "รหัสสาขา (VAT CODE)"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_vatcode",
                                                            placeholder: "กรอกรหัสสาขา (VAT CODE)",
                                                            value: partnerData.bus_business_vatcode != null && partnerData.bus_business_vatcode != "" ? partnerData.bus_business_vatcode : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ชื่อสาขา"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_branchname",
                                                            placeholder: "กรอกชื่อสาขา",
                                                            value: partnerData.bus_business_branchname != null && partnerData.bus_business_branchname != "" ? partnerData.bus_business_branchname : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ชื่อย่อ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_shortname",
                                                            placeholder: "กรอกชื่อย่อ",
                                                            value: partnerData.bus_business_shortname != null && partnerData.bus_business_shortname != "" ? partnerData.bus_business_shortname : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ประเภท"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Form.Select, {
                                                            name: "bus_business_businesstype",
                                                            className: "w-100 select-st-1",
                                                            disabled: formDisabled,
                                                            onChange: function(e) {
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    bus_business_businesstype: e.value
                                                                }));
                                                            },
                                                            value: partnerData.bus_business_businesstype,
                                                            children: [
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "",
                                                                    children: "เลือกประเภท"
                                                                }),
                                                                optionsBusinessTypes.map(function(value, index) {
                                                                    return /*#__PURE__*/ _jsx("option", {
                                                                        value: value.value,
                                                                        children: value.label
                                                                    }, index);
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "คำนำหน้าชื่อ"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Form.Select, {
                                                            name: "bus_business_prefixid",
                                                            className: "w-100 select-st-1",
                                                            disabled: formDisabled,
                                                            onChange: function(e) {
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    bus_business_prefixid: e.value
                                                                }));
                                                            },
                                                            value: partnerData.bus_business_prefixid,
                                                            children: [
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "",
                                                                    children: "เลือกคำนำหน้าชื่อ"
                                                                }),
                                                                optionsMstPrefix.map(function(value, index) {
                                                                    return /*#__PURE__*/ _jsx("option", {
                                                                        value: value.value,
                                                                        children: value.label
                                                                    }, index);
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ชื่อ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_fname",
                                                            placeholder: "กรอกชื่อ",
                                                            value: partnerData.bus_business_fname != null && partnerData.bus_business_fname != "" ? partnerData.bus_business_fname : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 4,
                                                xl: 2,
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "นามสกุล"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "bus_business_lname",
                                                            placeholder: "กรอกนามสกุล",
                                                            value: partnerData.bus_business_lname != null && partnerData.bus_business_lname != "" ? partnerData.bus_business_lname : "-",
                                                            onChange: function() {},
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-20 fw-bold tc-5 mb-3",
                                children: "ที่อยู่ธุรกิจ"
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: 8,
                                        xl: 4,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ที่อยู่ธุรกิจ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_address",
                                                    placeholder: "กรอกที่อยู่",
                                                    value: partnerData.bus_business_address != null && partnerData.bus_business_address != "" ? partnerData.bus_business_address : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "จังหวัด"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    name: "bus_business_provinceid",
                                                    className: "w-100 select-st-1",
                                                    disabled: formDisabled,
                                                    onChange: function(e) {
                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                            bus_business_provinceid: e.value
                                                        }));
                                                        setProvinceId(e.value);
                                                    },
                                                    value: partnerData.bus_business_provinceid,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: "",
                                                            children: "เลือกจังหวัด"
                                                        }),
                                                        optionsProvince.map(function(value, index) {
                                                            return /*#__PURE__*/ _jsx("option", {
                                                                value: value.value,
                                                                children: value.label
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "อำเภอ/เขต"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    name: "bus_business_districtid",
                                                    className: "w-100 select-st-1",
                                                    disabled: formDisabled,
                                                    onChange: function(e) {
                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                            bus_business_subprovinceid: e.value
                                                        }));
                                                    },
                                                    value: partnerData.bus_business_subprovinceid,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: "",
                                                            children: "เลือกอำเภอ/เขต"
                                                        }),
                                                        optionsDistrict.map(function(value, index) {
                                                            return /*#__PURE__*/ _jsx("option", {
                                                                value: value.value,
                                                                children: value.label
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "แขวง/ตำบล"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    name: "bus_business_districtid",
                                                    className: "w-100 select-st-1",
                                                    disabled: formDisabled,
                                                    onChange: function(e) {
                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                            bus_business_districtid: e.value
                                                        }));
                                                    },
                                                    value: partnerData.bus_business_districtid,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: "",
                                                            children: "เลือกแขวง/ตำบล"
                                                        }),
                                                        optionsSubDistrict.map(function(value, index) {
                                                            return /*#__PURE__*/ _jsx("option", {
                                                                value: value.value,
                                                                children: value.label
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "รหัสไปรษณีย์"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_zipcodeid",
                                                    placeholder: "กรอกรหัสไปรษณีย์",
                                                    value: partnerData.bus_business_zipcodeid != null && partnerData.bus_business_zipcodeid != "" ? partnerData.bus_business_zipcodeid : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์โทรศัพท์"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_tel",
                                                    placeholder: "กรอกเบอร์โทรศัพท์",
                                                    value: partnerData.bus_business_tel != null && partnerData.bus_business_tel != "" ? partnerData.bus_business_tel : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์มือถือ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_phone",
                                                    placeholder: "กรอกเบอร์มือถือ",
                                                    value: partnerData.bus_business_phone != null && partnerData.bus_business_phone != "" ? partnerData.bus_business_phone : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "อีเมล"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "email",
                                                    name: "bus_business_email",
                                                    placeholder: "กรอกอีเมล",
                                                    value: partnerData.bus_business_email != null && partnerData.bus_business_email != "" ? partnerData.bus_business_email : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "d-flex align-items-center gap-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "fs-20 fw-bold tc-5 my-4",
                                    children: "ที่อยู่จัดส่งเอกสาร"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: 8,
                                        xl: 4,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ที่อยู่ธุรกิจ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_docaddress",
                                                    placeholder: "กรอกที่อยู่",
                                                    value: partnerData.bus_business_docaddress != null && partnerData.bus_business_docaddress != "" ? partnerData.bus_business_docaddress : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "จังหวัด"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    name: "bus_business_docprovinceid",
                                                    className: "w-100 select-st-1",
                                                    disabled: formDisabled,
                                                    onChange: function(e) {
                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                            bus_business_docprovinceid: e.value
                                                        }));
                                                    },
                                                    value: partnerData.bus_business_docprovinceid,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: "",
                                                            children: "เลือกจังหวัด"
                                                        }),
                                                        optionsProvince.map(function(value, index) {
                                                            return /*#__PURE__*/ _jsx("option", {
                                                                value: value.value,
                                                                children: value.label
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "อำเภอ/เขต"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    name: "bus_business_docsubprovinceid",
                                                    className: "w-100 select-st-1",
                                                    disabled: formDisabled,
                                                    onChange: function(e) {
                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                            bus_business_docsubprovinceid: e.value
                                                        }));
                                                    },
                                                    value: partnerData.bus_business_docsubprovinceid,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: "",
                                                            children: "เลือกอำเภอ/เขต"
                                                        }),
                                                        optionsDistrictSub.map(function(value, index) {
                                                            return /*#__PURE__*/ _jsx("option", {
                                                                value: value.value,
                                                                children: value.label
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "แขวง/ตำบล"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    name: "bus_business_docdistrictid",
                                                    className: "w-100 select-st-1",
                                                    disabled: formDisabled,
                                                    onChange: function(e) {
                                                        setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                            bus_business_docdistrictid: e.value
                                                        }));
                                                    },
                                                    value: partnerData.bus_business_docdistrictid,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: "",
                                                            children: "เลือกแขวง/ตำบล"
                                                        }),
                                                        optionsSubDistrictSub.map(function(value, index) {
                                                            return /*#__PURE__*/ _jsx("option", {
                                                                value: value.value,
                                                                children: value.label
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "รหัสไปรษณีย์"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_doczipcodeid",
                                                    placeholder: "กรอกรหัสไปรษณีย์",
                                                    value: partnerData.bus_business_doczipcodeid != null && partnerData.bus_business_doczipcodeid != "" ? partnerData.bus_business_doczipcodeid : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์โทรศัพท์"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_doctel",
                                                    placeholder: "กรอกเบอร์โทรศัพท์",
                                                    value: partnerData.bus_business_doctel != null && partnerData.bus_business_doctel != "" ? partnerData.bus_business_doctel : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์มือถือ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_docphone",
                                                    placeholder: "กรอกเบอร์มือถือ",
                                                    value: partnerData.bus_business_docphone != null && partnerData.bus_business_docphone != "" ? partnerData.bus_business_docphone : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "อีเมล"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "email",
                                                    name: "bus_business_docemail",
                                                    placeholder: "กรอกอีเมล",
                                                    value: partnerData.bus_business_docemail != null && partnerData.bus_business_docemail != "" ? partnerData.bus_business_docemail : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "วันที่สร้าง"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_credate",
                                                    placeholder: "-",
                                                    value: partnerData.bus_business_credate != null && partnerData.bus_business_credate != "" ? moment(partnerData.bus_business_credate).format("DD/MM/YYYY") : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ผู้สร้าง"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "mb_mem_fullname",
                                                    placeholder: "-",
                                                    value: partnerData.mb_mem_fullname != null && partnerData.mb_mem_fullname != "" ? partnerData.mb_mem_fullname : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                partnerData.bus_business_status == 3 || partnerData.bus_business_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                    className: "justify-content-end",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: "auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-flex gap-2 mb-3 mt-3",
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "outline-secondary",
                                onClick: onBackPage,
                                children: "ย้อนกลับ"
                            })
                        })
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            ]
        })
    });
}
// function TaxIDModal({ partnerData, setPartnerData, ...props }) {
//     const { ...rest } = props;
//     const [tabledata, setTabledata] = useState([]);
//     const [taxID, setTaxID] = useState();
//     const [data, setData] = useState([
//       {
//         tax_identification_number: "0565556000251",
//         company_name: "บริษัท อินเตอร์ คอฟฟี่เทรด จำกัด",
//         businessAddress:
//           "19/7 ถนน ฟากน้ำ ตำบล แม่ต่ำ อำเภอ เมืองพะเยา จังหวัด พะเยา 56000",
//         company_branch_name: "สำนักงานใหญ่",
//       },
//     ]);
//     const handleClick = (val) => {
//         setPartnerData((prev) => ({
//         ...prev,
//         tax_identification_number: val.tax_identification_number,
//         company_name: val.company_name,
//         company_branch_name: val.company_branch_name,
//         company_address: val.businessAddress,
//         dim_mst_business_type_id: 2,
//       }));
//       props.onHide();
//     };
//     const columns = [
//       {
//         name: "เลขผู้เสียภาษี",
//         selector: (row) => row.tax_identification_number,
//         width: "170px",
//       },
//       {
//         name: "ชื่อบริษัท",
//         selector: (row) => row.company_name,
//         cell: (row) => <div>{row.company_name} </div>,
//         width: "200px",
//       },
//       {
//         name: "สาขา",
//         selector: (row) => row.company_branch_name,
//         width: "170px",
//       },
//       {
//         name: "ที่อยู่",
//         selector: (row) => row.businessAddress,
//         cell: (row) => <div>{row.businessAddress} </div>,
//       },
//       {
//         name: "ตัวเลือก",
//         selector: (row) => row.tax_identification_number,
//         center: true,
//         width: "120px",
//         cell: (row) => (
//           <Button
//             type="button"
//             className=" btn-st-3"
//             onClick={() => handleClick(row)}
//           >
//             เลือก
//           </Button>
//         ),
//       },
//     ];
//     return (
//       <Modal {...rest} size="xl" centered>
//         <Modal.Body>
//           <div className="d-flex align-items-center px-3 py-2 mb-4 pb-3">
//             <div
//               className="fs-24 fw-bold me-auto"
//               style={{ color: "rgba(76, 78, 100, 0.87)" }}
//             >
//               ค้นหาข้อมูลจากฐานข้อมูลกรมสรรพากร
//             </div>
//             <button
//               onClick={props.onHide}
//               className="btn btn-close-modal"
//             ></button>
//           </div>
//           <div className=" px-3 d-flex align-items-center mb-3">
//             <Form.Group
//               className="mb-2 form-st-3   pb-1"
//               style={{ width: "400px" }}
//             >
//               <Form.Label className="mb-1">เลขที่ประจำตัวผู้เสียภาษี</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="tax_identification_number"
//                 className="form-control"
//                 placeholder="เลขที่ประจำตัวผู้เสียภาษี"
//                 value={taxID}
//                 onChange={(e) => setTaxID(e.target.value)}
//                 maxLength={13}
//               />
//             </Form.Group>
//             <button
//               type="button"
//               className="btn btn-st-3 ms-3 me-auto py-2 fs-18 px-2"
//               onClick={() => setTabledata(data)}
//             >
//               ค้นหาจาก TAX ID
//             </button>
//             <div>
//               ผลการค้นหา <span>{tabledata.length}</span> รายการ
//             </div>
//           </div>
//           <div className="px-3">
//             <DataTableLayout
//               item={tabledata}
//               columns={columns}
//               isSelectRows={false}
//               PerPage={10}
//             />
//           </div>
//         </Modal.Body>
//       </Modal>
//     );
// }
function ApproveModal(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), vendorCode = _useState[0], setVendorCode = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var updateStatusPartnerReducer = useAppSelector(function(state) {
        return state.updateStatusPartnerReducer;
    });
    var handleChange = function(e) {
        setVendorCode(e.target.value);
    };
    var handleClick = function(val) {
        // if (vendorCode && vendorCode.trim() !== "") {
        setIsLoading(true);
        var payload = {
            status: 3,
            //vendorCode: vendorCode,
            comment: "อนุมัติ Partner"
        };
        dispatch(updateStatusPartner(partnerId, payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setIsBoxAlert(true);
        setVendorCode("");
        props.onHide();
    // }
    // else {
    //     setModalObj({
    //         ...modalObj,
    //         visible: true,
    //         subTitle: `รหัส 201`,
    //         navigateDirection: undefined,
    //         title: `กรุณากรอก Vendor Code`
    //     });
    //     props.onHide();
    // }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusPartnerReducer.isFetching);
        if (updateStatusPartnerReducer.data && !updateStatusPartnerReducer.isError) {
            var updatedData = updateStatusPartnerReducer.data.data;
            dispatch(clearUpdateStatusPartner());
            props.redata();
            if (isBoxAlert) {
                props.onAlert();
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "อนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Badge, {
                    bg: "danger-light",
                    text: "dark",
                    children: [
                        /*#__PURE__*/ _jsx(InfoIcon, {
                            sx: {
                                color: "#B00412"
                            },
                            className: "mr-2"
                        }),
                        "คุณต้องการที่จะอนุมัติข้อมูล Partner นี้หรือไม่"
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function SendEditModal(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), remark = _useState[0], setRemark = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var updateStatusPartnerReducer = useAppSelector(function(state) {
        return state.updateStatusPartnerReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function() {
        if (remark && remark.trim() !== "") {
            setIsLoading(true);
            var payload = {
                status: 4,
                vendorCode: "",
                comment: remark
            };
            dispatch(updateStatusPartner(partnerId, payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            setRemark("");
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการแก้ไข"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusPartnerReducer.isFetching);
        if (updateStatusPartnerReducer.data && !updateStatusPartnerReducer.isError) {
            var updatedData = updateStatusPartnerReducer.data.data;
            dispatch(clearUpdateStatusPartner());
            props.redata();
            if (isBoxAlert) {
                props.onAlert();
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ส่งกลับไปแก้ไขอนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center mt-3",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการแก้ไข ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-red-gb",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "remark_partner_set",
                                    placeholder: "กรอกคำอธิบาย",
                                    style: {
                                        resize: "none"
                                    },
                                    onChange: handleChange
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function NoApproveModal(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), remark = _useState[0], setRemark = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var updateStatusPartnerReducer = useAppSelector(function(state) {
        return state.updateStatusPartnerReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function() {
        if (remark && remark.trim() !== "") {
            setIsLoading(true);
            var payload = {
                status: 5,
                vendorCode: "",
                comment: remark
            };
            dispatch(updateStatusPartner(partnerId, payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            setRemark("");
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการไม่อนุมัติ"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusPartnerReducer.isFetching);
        if (updateStatusPartnerReducer.data && !updateStatusPartnerReducer.isError) {
            var updatedData = updateStatusPartnerReducer.data.data;
            dispatch(clearUpdateStatusPartner());
            props.redata();
            if (isBoxAlert) {
                props.onAlert();
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ไม่อนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center mt-3",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการไม่อนุมัติ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-red-gb",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "remark_noapprove",
                                    placeholder: "กรอกคำอธิบาย",
                                    style: {
                                        resize: "none"
                                    },
                                    onChange: handleChange
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function ProductDetailView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var partnerId = useParams().partnerId;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), excelData = _useState1[0], setExcelData = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), tabMenuTb = _useState2[0], setTabMenuTb = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), filteredItems = _useState3[0], setFilteredItems = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), filterText = _useState4[0], setFilterText = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), statusItem = _useState5[0], setStatusItem = _useState5[1];
    var loadAllMsts = function() {
        dispatch(getPartnerProductById(parseInt(partnerId, 10), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getPartnerProductByIdReducer = useAppSelector(function(state) {
        return state.getPartnerProductByIdReducer;
    });
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getPartnerProductByIdReducer.isFetching);
        if (getPartnerProductByIdReducer.data && !getPartnerProductByIdReducer.isError) {
            var datas = getPartnerProductByIdReducer.data.data;
            if (datas) {
                setTabledata(datas.map(function(item) {
                    return _object_spread_props(_object_spread({}, item), {
                        datail: item.PdPdetail
                    });
                }));
            }
        }
    }, [
        getPartnerProductByIdReducer
    ]);
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.pd_product_code;
            },
            center: "true",
            width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_products",
                        children: row.pd_product_code ? row.pd_product_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "รูป",
            selector: function(row) {
                return row.pd_product_image;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: row.pd_product_image ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: row.pd_product_image ? getFullUrlPath(row.pd_product_image) : "",
                            className: "imgprofile"
                        })
                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                });
            },
            width: "160px",
            center: "true"
        },
        {
            name: "ชื่อสินค้า",
            width: "200px",
            selector: function(row) {
                return row.pd_product_nameth;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.pd_product_nameth,
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption",
                            children: row.pd_product_barcode
                        })
                    ]
                });
            }
        },
        {
            name: "ราคานำเสนอ",
            center: "true",
            width: "170px",
            selector: function(row) {
                return row.pd_product_price;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.pd_product_price && row.pd_product_price >= 0 ? NumberFormatFloat(row.pd_product_price, 2) : "-"
                });
            }
        },
        {
            name: "ราคาแนะนำขาย",
            center: "true",
            width: "170px",
            selector: function(row) {
                return row.pd_product_recommentprice;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.pd_product_recommentprice && row.pd_product_recommentprice >= 0 ? NumberFormatFloat(row.pd_product_recommentprice, 2) : "-"
                });
            }
        },
        {
            name: "วันที่อนุมัติ",
            center: "true",
            width: "170px",
            selector: function(row) {
                return row.pd_product_approvedate ? moment(row.pd_product_approvedate).format("DD/MM/YYYY") : "-";
            }
        },
        {
            name: "วันที่ทำสัญญา",
            center: "true",
            width: "170px",
            selector: function(row) {
                return row.pd_product_contractdate ? moment(row.pd_product_contractdate).format("DD/MM/YYYY") : "-";
            }
        },
        {
            name: "วันที่หมดสัญญา",
            center: "true",
            width: "170px",
            selector: function(row) {
                return row.pd_product_contractdateend ? moment(row.pd_product_contractdateend).format("DD/MM/YYYY") : "-";
            }
        },
        // {
        //   name: "สถานะ",
        //   center: "true",
        //   width: "170px",
        //   selector: (row) => row.pd_product_status,
        //   cell: (row, index, column, id) =>
        //     row.pd_product_status == 5 ? (
        //       <div
        //         className="px-2 py-1 text-center"
        //         style={{
        //           color: "rgba(211, 47, 47, 1)",
        //           backgroundColor: "rgba(253, 237, 237, 1)",
        //           borderRadius: "20px",
        //         }}
        //       >
        //         {"ยกเลิก"}
        //       </div>
        //     ) : row.bus_business_status == 4 ? (
        //         <div
        //             className="px-2 py-1 text-center"
        //             style={{
        //                 color: "#6f42c1",
        //                 backgroundColor: "#e2d9f3",
        //                 borderRadius: "20px",
        //                 width: "90px",
        //             }}
        //         >
        //             {'รอแก้ไข'}
        //         </div>
        //     ) : row.pd_product_status == 3 ? (
        //         <div
        //           className="px-2 py-1 text-center"
        //           style={{
        //             color: "rgba(114, 225, 40, 0.87)",
        //             backgroundColor: "rgba(238, 251, 229, 1)",
        //             borderRadius: "20px",
        //           }}
        //         >
        //           {"ทำสัญญาแล้ว"}
        //         </div>
        //     ) : row.pd_product_status == 2 ? (
        //       <div
        //         className="px-2 py-1 text-center"
        //         style={{
        //           color: "rgba(253, 180, 40, 1)",
        //           backgroundColor: "rgba(255, 246, 229, 1)",
        //           borderRadius: "20px",
        //         }}
        //       >
        //         {"รอทำสัญญา"}
        //       </div>
        //       ):(
        //       <div
        //         className="px-2 py-1 text-center"
        //         style={{
        //           color: "rgba(116, 116, 116, 1)",
        //           backgroundColor: "rgba(244, 244, 244, 1)",
        //           borderRadius: "20px",
        //         }}
        //       >
        //         {"ใบร่าง"}
        //       </div>
        //     ),
        // },
        {
            name: "สถานะ",
            center: "true",
            width: "170px",
            selector: function(row) {
                return row.pd_product_contractstatus;
            },
            cell: function(row, index, column, id) {
                return row.pd_product_contractstatus == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(211, 47, 47, 1)",
                        backgroundColor: "rgba(253, 237, 237, 1)",
                        borderRadius: "20px"
                    },
                    children: "ยกเลิก"
                }) : row.pd_product_contractstatus == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px"
                    },
                    children: "ทำสัญญาแล้ว"
                }) : row.pd_product_contractstatus == 1 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px"
                    },
                    children: "รอทำสัญญา"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px"
                    },
                    children: "ไม่ระบุ"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.pd_product_id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(StackMui, {
                    direction: "row",
                    spacing: 1,
                    sx: {
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_products",
                        children: row.pd_product_id ? /*#__PURE__*/ _jsx(Avatar, {
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                sx: {
                                    fontSize: 25
                                }
                            })
                        }) : "-"
                    })
                });
            },
            width: "170px",
            center: "true"
        }
    ];
    var columnsDetail = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return "-";
            },
            center: "true",
            width: "170px"
        },
        {
            name: "บาร์โค๊ด",
            selector: function(row) {
                return row.pd_pdetail_barcode;
            },
            center: "true",
            width: "170px"
        },
        {
            name: "คุณสมบัติสินค้า",
            selector: function(row) {
                return "-";
            },
            center: "true",
            width: "170px"
        },
        {
            name: "หน่วยสินค้า",
            selector: function(row) {
                return row.pd_pdetail_unitid;
            },
            center: "true",
            width: "170px"
        },
        {
            name: "อัตตราส่วน",
            selector: function(row) {
                return row.pd_pdetail_ratio;
            },
            center: "true",
            width: "170px"
        },
        {
            name: "ราคานำเสนอ",
            selector: function(row) {
                return row.pd_pdetail_price;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.pd_pdetail_price && row.pd_pdetail_price >= 0 ? NumberFormatFloat(row.pd_pdetail_price, 2) : "-"
                });
            },
            center: "true",
            width: "170px"
        },
        {
            name: "ราคาแนะนำ",
            selector: function(row) {
                return row.pd_pdetail_recommentprice;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.pd_pdetail_recommentprice && row.pd_pdetail_recommentprice >= 0 ? NumberFormatFloat(row.pd_pdetail_recommentprice, 2) : "-"
                });
            },
            center: "true",
            width: "170px"
        },
        {
            name: "GP %",
            selector: function(row) {
                return row.pd_pdetail_gp;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px"
                    },
                    children: NumberFormatFloat(row.pd_pdetail_gp, 2) + " %"
                });
            },
            center: "true",
            width: "170px"
        }
    ];
    useEffect(function() {
        if (statusItem && statusItem > 0 && filterText && filterText != "" && filterText != null) {
            setFilteredItems(tabledata.filter(function(item) {
                return item.pd_product_id !== null && item.pd_product_contractstatus == statusItem && (item.pd_product_code != null && item.pd_product_code.toUpperCase().includes(filterText.toUpperCase()) || item.pd_product_barcode != null && item.pd_product_barcode.toUpperCase().includes(filterText.toUpperCase()) || item.pd_product_nameth != null && item.pd_product_nameth.includes(filterText) || item.pd_product_nameen != null && item.pd_product_nameen.includes(filterText));
            }));
        } else if (statusItem && statusItem > 0 && (!filterText || filterText == "")) {
            setFilteredItems(tabledata.filter(function(item) {
                return item.pd_product_id !== null && item.pd_product_contractstatus == statusItem;
            }));
        } else if (filterText && filterText != "" && filterText != null && statusItem <= 0) {
            setFilteredItems(tabledata.filter(function(item) {
                return item.pd_product_id !== null && (item.pd_product_code != null && item.pd_product_code.toUpperCase().includes(filterText.toUpperCase()) || item.pd_product_barcode != null && item.pd_product_barcode.toUpperCase().includes(filterText.toUpperCase()) || item.pd_product_nameth != null && item.pd_product_nameth.includes(filterText) || item.pd_product_nameen != null && item.pd_product_nameen.includes(filterText));
            }));
        } else {
            setFilteredItems(tabledata.filter(function(item) {
                return item.pd_product_id !== null && item.pd_product_status > 1;
            }));
        }
    }, [
        tabledata,
        statusItem,
        filterText
    ]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            filteredItems.map(function(item, index) {
                if (item.pd_product_id && item.pd_product_id != "" && item.pd_product_id > 0) {
                    setExcelData(function(excelData) {
                        return _to_consumable_array(excelData).concat([
                            {
                                product_no: index + 1,
                                product_code: item.pd_product_code && item.pd_product_code != null && item.pd_product_code != "" ? item.pd_product_code : "-",
                                product_img: item.pd_product_image && item.pd_product_image != null && item.pd_product_image != "" ? item.pd_product_image : "-",
                                product_name_th: item.pd_product_nameth && item.pd_product_nameth != null && item.pd_product_nameth != "" ? item.pd_product_nameth : "-",
                                product_name_en: item.pd_product_nameen && item.pd_product_nameen != null && item.pd_product_nameen != "" ? item.pd_product_nameen : "-",
                                product_barcode: item.pd_product_barcode && item.pd_product_barcode != null && item.pd_product_barcode != "" ? item.pd_product_barcode : "-",
                                product_price: item.pd_product_price && item.pd_product_price >= 0 ? NumberFormatFloat(item.pd_product_price, 2) : "-",
                                recomment_price: item.pd_product_recommentprice && item.pd_product_recommentprice >= 0 ? NumberFormatFloat(item.pd_product_recommentprice, 2) : "-",
                                approve_date: item.pd_product_approvedate && item.pd_product_approvedate != null && item.pd_product_approvedate != "" ? moment(item.pd_product_approvedate).format("DD/MM/YYYY") : "-",
                                contract_date: item.pd_product_contractdate && item.pd_product_contractdate != null && item.pd_product_contractdate != "" ? moment(item.pd_product_contractdate).format("DD/MM/YYYY") : "-",
                                contract_date_end: item.pd_product_contractdateend && item.pd_product_contractdateend != null && item.pd_product_contractdateend != "" ? moment(item.pd_product_contractdateend).format("DD/MM/YYYY") : "-",
                                status: item.pd_product_contractstatus && item.pd_product_contractstatus == 3 ? "ยกเลิก" : item.pd_product_contractstatus && item.pd_product_contractstatus == 2 ? "ทำสัญญาแล้ว" : item.pd_product_contractstatus && item.pd_product_contractstatus == 1 ? "รอทำสัญญา" : "แบบร่าง"
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        filteredItems
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(1);
                                setStatusItem(0);
                            },
                            active: tabMenuTb == 1 ? true : false,
                            children: "ทั้งหมด"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(2);
                                setStatusItem(1);
                            },
                            active: tabMenuTb == 2 ? true : false,
                            children: "รอทำสัญญา"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(3);
                                setStatusItem(2);
                            },
                            active: tabMenuTb == 3 ? true : false,
                            children: "ทำสัญญาแล้ว"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(4);
                                setStatusItem(3);
                            },
                            active: tabMenuTb == 4 ? true : false,
                            children: "ยกเลิก"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 7,
                                    className: "mb-2",
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: excelData,
                                        filename: "product_" + moment().format("YYYYMMDDHHmmss")
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 5,
                                    className: "mb-2",
                                    children: /*#__PURE__*/ _jsx(Stack, {
                                        direction: "horizontal",
                                        children: /*#__PURE__*/ _jsx("input", {
                                            type: "text",
                                            className: "form-control form-st-4",
                                            placeholder: "ค้นหารหัส,ชื่อสินค้า,รหัสบาร์โค้ด",
                                            onKeyUp: function(e) {
                                                return setFilterText(e.target.value);
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(RowExpansion, {
                            data: filteredItems,
                            columns: columns,
                            columnsDetail: columnsDetail,
                            isSelectRows: true,
                            PerPage: 10
                        }),
                        partnerData.bus_business_status == 3 || partnerData.bus_business_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                            className: "justify-content-end",
                            children: /*#__PURE__*/ _jsx(Col, {
                                xs: "auto",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "d-flex gap-2 mb-3 mt-3",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline-secondary",
                                        onClick: props.onBackPage,
                                        children: "ย้อนกลับ"
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                    ]
                })
            })
        ]
    });
}
function HistoryEditView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), tabMenuTb = _useState1[0], setTabMenuTb = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), taxID = _useState2[0], setTaxID = _useState2[1];
    var _useState3 = _sliced_to_array(useState(historyRowData), 2), filteredItems = _useState3[0], setFilteredItems = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), filterText = _useState4[0], setFilterText = _useState4[1];
    var columns = [
        {
            name: "วันที่",
            center: "true",
            width: "200px",
            selector: function(row) {
                return row.sendDate;
            }
        },
        {
            name: "ชื่อผู้ส่ง",
            width: "200px",
            selector: function(row) {
                return row.id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: row.partnerId > 0 ? row.partnerName : row.adminId > 0 ? row.adminName : "-"
                });
            }
        },
        {
            name: "หมายเหตุ",
            selector: function(row) {
                return row.remark;
            }
        }
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Card, {
            className: "card-st-1 mb-4",
            children: /*#__PURE__*/ _jsxs(CardBody, {
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 6,
                                lg: 7,
                                className: "mb-2",
                                children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: filteredItems,
                                    filename: "manage_partner_history_edit"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 6,
                                lg: 5,
                                className: "mb-2",
                                children: /*#__PURE__*/ _jsx(Stack, {
                                    direction: "horizontal",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาวันที่,ชื่อผู้ส่ง",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(DataTableLayout, {
                        item: filteredItems,
                        columns: columns,
                        isSelectRows: true,
                        PerPage: 10
                    })
                ]
            })
        })
    });
}
function ContactPartnerView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-1 mb-4",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ _jsx(Form, {
                    children: /*#__PURE__*/ _jsxs("fieldset", {
                        disabled: props.formDisabled,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-20 fw-bold tc-5 mb-2",
                                children: "ผู้ติดต่อหลัก"
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ชื่อ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_mainfname",
                                                    placeholder: "กรอกชื่อ",
                                                    value: partnerData.bus_business_mainfname != null && partnerData.bus_business_mainfname != "" ? partnerData.bus_business_mainfname : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "นามสกุล"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_mainlname",
                                                    placeholder: "กรอกนามสกุล",
                                                    value: partnerData.bus_business_mainlname != null && partnerData.bus_business_mainlname != "" ? partnerData.bus_business_mainlname : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ชื่อเล่น"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_mainnname",
                                                    placeholder: "กรอกชื่อเล่น",
                                                    value: partnerData.bus_business_mainnname != null && partnerData.bus_business_mainnname != "" ? partnerData.bus_business_mainnname : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "อีเมล"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_mainemail",
                                                    placeholder: "กรอกอีเมล",
                                                    value: partnerData.bus_business_mainemail != null && partnerData.bus_business_mainemail != "" ? partnerData.bus_business_mainemail : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์โทรศัพท์"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_maintel",
                                                    placeholder: "กรอกเบอร์โทร",
                                                    value: partnerData.bus_business_maintel != null && partnerData.bus_business_maintel != "" ? partnerData.bus_business_maintel : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์มือถือ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_mainphone",
                                                    placeholder: "กรอกเบอร์มือถือ",
                                                    value: partnerData.bus_business_mainphone != null && partnerData.bus_business_mainphone != "" ? partnerData.bus_business_mainphone : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ตำแหน่ง"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_mainposition",
                                                    placeholder: "กรอกตำแหน่ง",
                                                    value: partnerData.bus_business_mainposition != null && partnerData.bus_business_mainposition != "" ? partnerData.bus_business_mainposition : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-20 fw-bold tc-5 mb-2",
                                children: "ผู้ติดต่อสำรอง"
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ชื่อ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_subfname",
                                                    placeholder: "กรอกชื่อ",
                                                    value: partnerData.bus_business_subfname != null && partnerData.bus_business_subfname != "" ? partnerData.bus_business_subfname : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "นามสกุล"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_sublname",
                                                    placeholder: "กรอกนามสกุล",
                                                    value: partnerData.bus_business_sublname != null && partnerData.bus_business_sublname != "" ? partnerData.bus_business_sublname : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ชื่อเล่น"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_subnname",
                                                    placeholder: "กรอกชื่อเล่น",
                                                    value: partnerData.bus_business_subnname != null && partnerData.bus_business_subnname != "" ? partnerData.bus_business_subnname : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "อีเมล"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_subemail",
                                                    placeholder: "กรอกอีเมล",
                                                    value: partnerData.bus_business_subemail != null && partnerData.bus_business_subemail != "" ? partnerData.bus_business_subemail : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์โทรศัพท์"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_subtel",
                                                    placeholder: "กรอกเบอร์โทร",
                                                    value: partnerData.bus_business_subtel != null && partnerData.bus_business_subtel != "" ? partnerData.bus_business_subtel : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เบอร์มือถือ"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_subphone",
                                                    placeholder: "กรอกเบอร์มือถือ",
                                                    value: partnerData.bus_business_subphone != null && partnerData.bus_business_subphone != "" ? partnerData.bus_business_subphone : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ตำแหน่ง"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_subposition",
                                                    placeholder: "กรอกตำแหน่ง",
                                                    value: partnerData.bus_business_subposition != null && partnerData.bus_business_subposition != "" ? partnerData.bus_business_subposition : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                partnerData.bus_business_status == 3 || partnerData.bus_business_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                    className: "justify-content-end",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: "auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-flex gap-2 mb-3 mt-3",
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "outline-secondary",
                                onClick: props.onBackPage,
                                children: "ย้อนกลับ"
                            })
                        })
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            ]
        })
    });
}
function SocialPartnerView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-1 mb-4",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ _jsx(Form, {
                    children: /*#__PURE__*/ _jsxs("fieldset", {
                        disabled: props.formDisabled,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-20 fw-bold tc-5 mb-2",
                                children: "ข้อมูล Social"
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "E-mail"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_soemail",
                                                    placeholder: "กรอก E-mail",
                                                    value: partnerData.bus_business_soemail != null && partnerData.bus_business_soemail != "" ? partnerData.bus_business_soemail : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "Website"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_sowebsite",
                                                    placeholder: "กรอก Website",
                                                    value: partnerData.bus_business_sowebsite != null && partnerData.bus_business_sowebsite != "" ? partnerData.bus_business_sowebsite : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "Facebook"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_sofb",
                                                    placeholder: "กรอก Facebook",
                                                    value: partnerData.bus_business_sofb != null && partnerData.bus_business_sofb != "" ? partnerData.bus_business_sofb : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "Line Oa"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_solineoa",
                                                    placeholder: "กรอก Line Oa",
                                                    value: partnerData.bus_business_solineoa != null && partnerData.bus_business_solineoa != "" ? partnerData.bus_business_solineoa : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "IG"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_soig",
                                                    placeholder: "กรอก IG",
                                                    value: partnerData.bus_business_soig != null && partnerData.bus_business_soig != "" ? partnerData.bus_business_soig : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "TIKTOK"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_sotiktok",
                                                    placeholder: "กรอก TIKTOK",
                                                    value: partnerData.bus_business_sotiktok != null && partnerData.bus_business_sotiktok != "" ? partnerData.bus_business_sotiktok : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "Shopee"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_soshopee",
                                                    placeholder: "กรอก Shopee",
                                                    value: partnerData.bus_business_soshopee != null && partnerData.bus_business_soshopee != "" ? partnerData.bus_business_soshopee : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "Lazada"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_solazada",
                                                    placeholder: "กรอกลิงค์อื่นๆ",
                                                    value: partnerData.bus_business_solazada != null && partnerData.bus_business_solazada != "" ? partnerData.bus_business_solazada : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "URL Google Map"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "bus_business_urlmap",
                                                    placeholder: "กรอก URL Google Map",
                                                    value: partnerData.bus_business_urlmap != null && partnerData.bus_business_urlmap != "" ? partnerData.bus_business_urlmap : "-",
                                                    onChange: function() {},
                                                    readOnly: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                partnerData.bus_business_status == 3 || partnerData.bus_business_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                    className: "justify-content-end",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: "auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-flex gap-2 mb-3 mt-3",
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "outline-secondary",
                                onClick: props.onBackPage,
                                children: "ย้อนกลับ"
                            })
                        })
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            ]
        })
    });
}
function BankPartnerView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, approveBank = _param.approveBank, setApproveBank = _param.setApproveBank, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData",
        "approveBank",
        "setApproveBank"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var partnerId = useParams().partnerId;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState([]), 2), optionsMstBank = _useState[0], setOptionsMstBank = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsBankType = _useState1[0], setOptionsBankType = _useState1[1];
    var _useState2 = _sliced_to_array(useState([
        {
            value: 1,
            label: "หน้าสมุดบัญชีธนาคาร"
        }
    ]), 2), optionsBankDocType = _useState2[0], setOptionsBankDocType = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), formdata = _useState3[0], setFormdata = _useState3[1];
    var loadAllMsts = function() {
        dispatch(getAllMstBank());
        dispatch(getAllMstBankAccountType());
        dispatch(getPartnerBankById(parseInt(partnerId, 10), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getAllMstBankReducer = useAppSelector(function(state) {
        return state.getAllMstBankReducer;
    });
    var getPartnerBankByIdReducer = useAppSelector(function(state) {
        return state.getPartnerBankByIdReducer;
    });
    var getAllMstBankAccountTypeReducer = useAppSelector(function(state) {
        return state.getAllMstBankAccountTypeReducer;
    });
    useEffect(function() {
        setIsLoading(getAllMstBankReducer.isFetching || getPartnerBankByIdReducer.isFetching || getAllMstBankAccountTypeReducer.isFetching);
        if (getAllMstBankReducer.data) {
            var options = mapMstToOptions(getAllMstBankReducer.data.data);
            setOptionsMstBank(_to_consumable_array(options));
        }
        if (getAllMstBankAccountTypeReducer.data) {
            var options1 = mapMstToOptions(getAllMstBankAccountTypeReducer.data.data);
            setOptionsBankType(_to_consumable_array(options1));
        }
        if (getPartnerBankByIdReducer.data && !getPartnerBankByIdReducer.isError) {
            var datas = getPartnerBankByIdReducer.data.data;
            if (datas) {
                setFormdata(datas);
            }
        }
    }, [
        getAllMstBankReducer,
        getPartnerBankByIdReducer,
        getAllMstBankAccountTypeReducer
    ]);
    useEffect(function() {
        if (partnerId || props.redata) {
            loadAllMsts();
            props.setRedata(false);
        }
    }, [
        partnerId,
        props.redata
    ]);
    var handleApproveBank = function() {
        return props.approveBankModal();
    };
    var handleSendEditBank = function() {
        return props.sendEditBankModal();
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-1 mb-4",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ _jsx(Form, {
                    children: /*#__PURE__*/ _jsxs("fieldset", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-20 fw-bold tc-5 mb-2",
                                children: "ข้อมูลธนาคารของคู่ค้า (สูงสุด 3 บัญชี)"
                            }),
                            formdata && formdata.length > 0 ? formdata.map(function(item, index) {
                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "tc-5 fs-18 mb-2 fw-bold ",
                                            children: [
                                                "บัญชีที่ ",
                                                index + 1
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Row, {
                                            className: "align-items-center mb-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 2,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ธนาคาร"
                                                            }),
                                                            /*#__PURE__*/ _jsxs(Form.Select, {
                                                                name: "bus_bank_bankid",
                                                                className: "w-100 select-st-1",
                                                                disabled: props.formDisabled,
                                                                onChange: function(e) {
                                                                    setFormdata(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                bus_bank_bankid: e.value
                                                                            }) : el;
                                                                        });
                                                                    });
                                                                },
                                                                value: item.bus_bank_bankid,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("option", {
                                                                        value: "",
                                                                        children: "เลือกธนาคาร"
                                                                    }),
                                                                    optionsMstBank.map(function(value, index2) {
                                                                        return /*#__PURE__*/ _jsx("option", {
                                                                            value: value.value,
                                                                            children: value.label
                                                                        }, index2);
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 2,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ประเภทบัญชี"
                                                            }),
                                                            /*#__PURE__*/ _jsxs(Form.Select, {
                                                                name: "bus_bank_type",
                                                                className: "w-100 select-st-1",
                                                                disabled: props.formDisabled,
                                                                onChange: function(e) {
                                                                    setFormdata(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                bus_bank_type: e.value
                                                                            }) : el;
                                                                        });
                                                                    });
                                                                },
                                                                value: item.bus_bank_type,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("option", {
                                                                        value: "",
                                                                        children: "เลือกประเภทบัญชี"
                                                                    }),
                                                                    optionsBankType.map(function(value, index2) {
                                                                        return /*#__PURE__*/ _jsx("option", {
                                                                            value: value.value,
                                                                            children: value.label
                                                                        }, index2);
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 2,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ชื่อบัญชี"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "bus_bank_name",
                                                                className: "form-control",
                                                                placeholder: "กรอกชื่อบัญชี",
                                                                value: item.bus_bank_name != null && item.bus_bank_name != "" ? item.bus_bank_name : "-",
                                                                onChange: function(e) {
                                                                    setFormdata(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                bus_bank_name: e.target.value
                                                                            }) : el;
                                                                        });
                                                                    });
                                                                },
                                                                disabled: props.formDisabled,
                                                                readOnly: true
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 2,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "เลขที่บัญชี"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "bus_bank_accountno",
                                                                placeholder: "กรอกเลขที่บัญชี",
                                                                value: item.bus_bank_accountno != null && item.bus_bank_accountno != "" ? item.bus_bank_accountno : "-",
                                                                onChange: function(e) {
                                                                    setFormdata(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                bus_bank_accountno: e.target.value
                                                                            }) : el;
                                                                        });
                                                                    });
                                                                },
                                                                disabled: props.formDisabled,
                                                                readOnly: true
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 2,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ชื่อสาขา"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "bank_account_branch",
                                                                placeholder: "กรอกชื่อสาขา",
                                                                value: item.bus_bank_branchn != null && item.bus_bank_branchn != "" ? item.bus_bank_branchn : "-",
                                                                onChange: function(e) {
                                                                    setFormdata(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                bus_bank_branchn: e.target.value
                                                                            }) : el;
                                                                        });
                                                                    });
                                                                },
                                                                disabled: props.formDisabled,
                                                                readOnly: true
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 2,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "หมายเหตุ"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "bus_bank_remark",
                                                                placeholder: "กรอกหมายเหตุ",
                                                                value: item.bus_bank_remark != null && item.bus_bank_remark != "" ? item.bus_bank_remark : "-",
                                                                onChange: function(e) {
                                                                    setFormdata(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                bus_bank_remark: e.target.value
                                                                            }) : el;
                                                                        });
                                                                    });
                                                                },
                                                                disabled: props.formDisabled,
                                                                readOnly: true
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "เอกสาร"
                                                            }),
                                                            /*#__PURE__*/ _jsxs(Form.Select, {
                                                                name: "bus_bank_doc_type",
                                                                className: "w-100 select-st-1",
                                                                disabled: props.formDisabled,
                                                                onChange: function(e) {
                                                                    setFormdata(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                bus_bank_doc_type: e.value
                                                                            }) : el;
                                                                        });
                                                                    });
                                                                },
                                                                value: item.bus_bank_doc_type && item.bus_bank_doc_type != "" ? item.bus_bank_doc_type : 1,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("option", {
                                                                        value: "",
                                                                        children: "เลือกประเภทเอกสาร"
                                                                    }),
                                                                    optionsBankDocType.map(function(value, index2) {
                                                                        return /*#__PURE__*/ _jsx("option", {
                                                                            value: value.value,
                                                                            children: value.label
                                                                        }, index2);
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                item.bus_bank_file != null && item.bus_bank_file != "" ? /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsx(DownloadFile, {
                                                        urlPath: item.bus_bank_file,
                                                        fileName: item.bus_bank_filename,
                                                        showIcon: true
                                                    })
                                                }) : /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 3,
                                                    children: /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-upload-file",
                                                        disabled: props.formDisabled,
                                                        onClick: function(e) {},
                                                        children: "อัปโหลดรูปภาพ"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    lg: 3,
                                                    xl: 4,
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "d-flex gap-3 mb-3 mt-3",
                                                        children: [
                                                            item.bus_bank_status != null && item.bus_bank_status > 0 ? /*#__PURE__*/ _jsx("div", {
                                                                children: /*#__PURE__*/ _jsx(StatusBankAndDoc, {
                                                                    statusNo: item.bus_bank_status
                                                                })
                                                            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                                                            /*#__PURE__*/ _jsx(Button, {
                                                                variant: "success",
                                                                onClick: function(e) {
                                                                    setApproveBank(function(prev) {
                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                            idBank: item.bus_bank_id,
                                                                            statusBank: 3,
                                                                            comment: "อนุมัติข้อมูลบัญชี " + item.bus_bank_name + " เลขบัญชี " + item.bus_bank_accountno
                                                                        });
                                                                    });
                                                                    handleApproveBank();
                                                                },
                                                                children: "อนุมัติ"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Button, {
                                                                variant: "warning",
                                                                onClick: function(e) {
                                                                    setApproveBank(function(prev) {
                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                            idBank: item.bus_bank_id,
                                                                            statusBank: 4,
                                                                            comment: "ส่งกลับแก้ไขข้อมูลบัญชี " + item.bus_bank_name + " เลขบัญชี " + item.bus_bank_accountno
                                                                        });
                                                                    });
                                                                    handleSendEditBank();
                                                                },
                                                                children: "ส่งกลับแก้ไข"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                            formdata.length < 3 ? /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsx(Row, {
                                    className: "align-items-center mb-3",
                                    children: /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            variant: "secondary",
                                            onClick: function() {},
                                            className: "btn-st-3",
                                            disabled: props.formDisabled,
                                            children: "+ บัญชี"
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    })
                }),
                partnerData.bus_business_status == 3 || partnerData.bus_business_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                    className: "justify-content-end",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: "auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-flex gap-2 mb-3 mt-3",
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "outline-secondary",
                                onClick: props.onBackPage,
                                children: "ย้อนกลับ"
                            })
                        })
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            ]
        })
    });
}
function DocumentPartnerView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, dataStatusDoc = _param.dataStatusDoc, setDataStatusDoc = _param.setDataStatusDoc, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData",
        "dataStatusDoc",
        "setDataStatusDoc"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var partnerId = useParams().partnerId;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState([
        {
            value: 1,
            label: "หนังสือรับรองบริษัท"
        },
        {
            value: 2,
            label: "ภพ.20"
        },
        {
            value: 3,
            label: "เอกสารของกรรมการผู้มีอำนาจลงนาม"
        },
        {
            value: 4,
            label: "เอกสารของผู้ดำเนินการ ( บัตรประชาชน )"
        },
        {
            value: 5,
            label: "เอกสารของผู้ดำเนินการ ( ทะเบียนบ้าน )"
        },
        {
            value: 6,
            label: "อื่นๆ"
        }
    ]), 2), optionsMstDoc = _useState[0], setOptionsMstDoc = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), formdata = _useState1[0], setFormdata = _useState1[1];
    var loadAllMsts = function() {
        dispatch(getPartnerDocById(parseInt(partnerId, 10), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllMstTypeDocument());
    };
    var getPartnerDocByIdReducer = useAppSelector(function(state) {
        return state.getPartnerDocByIdReducer;
    });
    var getAllMstTypeDocumentReducer = useAppSelector(function(state) {
        return state.getAllMstTypeDocumentReducer;
    });
    useEffect(function() {
        if (partnerId || props.redata) {
            loadAllMsts();
            props.setRedata(false);
        }
    }, [
        partnerId,
        props.redata
    ]);
    useEffect(function() {
        setIsLoading(getPartnerDocByIdReducer.isFetching || getAllMstTypeDocumentReducer.isFetching);
        if (getPartnerDocByIdReducer.data && !getPartnerDocByIdReducer.isError) {
            var datas = getPartnerDocByIdReducer.data.data;
            if (datas) {
                setFormdata(datas);
            }
        }
        if (getAllMstTypeDocumentReducer.data && !getAllMstTypeDocumentReducer.isError) {
            setOptionsMstDoc([]); // Clear existing options
            getAllMstTypeDocumentReducer.data.data.map(function(ele) {
                return setOptionsMstDoc(function(optionsMstDoc) {
                    return _to_consumable_array(optionsMstDoc).concat([
                        {
                            value: ele.bus_documents_id,
                            label: ele.bus_documents_name
                        }
                    ]);
                });
            });
        }
    }, [
        getPartnerDocByIdReducer,
        getAllMstTypeDocumentReducer
    ]);
    var handleApproveDoc = function() {
        return props.approveDocModal();
    };
    var handleSendEditDoc = function() {
        return props.sendEditDocModal();
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-1 mb-4",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ _jsx(Form, {
                    children: /*#__PURE__*/ _jsxs("fieldset", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-20 fw-bold tc-5 mb-2",
                                children: "เอกสารแนบ"
                            }),
                            formdata && formdata.length > 0 ? formdata.map(function(item, index) {
                                return /*#__PURE__*/ _jsxs(Row, {
                                    className: "align-items-center mb-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 2,
                                            md: 2,
                                            lg: 2,
                                            xl: "auto",
                                            children: /*#__PURE__*/ _jsxs("p", {
                                                className: "tc-5 fs-18 mb-2 fw-bold ",
                                                children: [
                                                    index + 1,
                                                    "."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 10,
                                            md: 5,
                                            lg: 4,
                                            xl: 3,
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "เอกสาร"
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Select, {
                                                        name: "bus_doc_typeid",
                                                        className: "w-100 select-st-1",
                                                        disabled: props.formDisabled,
                                                        onChange: function(e) {
                                                            setFormdata(function(prev) {
                                                                return prev.map(function(el) {
                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                        bus_doc_typeid: e.value
                                                                    }) : el;
                                                                });
                                                            });
                                                        },
                                                        value: item.bus_doc_typeid,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("option", {
                                                                value: "",
                                                                children: "เลือกประเภทเอกสาร"
                                                            }),
                                                            optionsMstDoc.map(function(value, index2) {
                                                                return /*#__PURE__*/ _jsx("option", {
                                                                    value: value.value,
                                                                    children: value.label
                                                                }, index2);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 5,
                                            lg: 4,
                                            xl: 3,
                                            children: item.bus_doc_name != null && item.bus_doc_name != "" ? /*#__PURE__*/ _jsx(DownloadFile, {
                                                urlPath: item.bus_doc_name,
                                                fileName: item.bus_doc_namedoc,
                                                showIcon: true
                                            }) : /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-upload-file",
                                                disabled: props.formDisabled,
                                                onClick: function(e) {},
                                                children: "อัปโหลดรูปภาพ"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 6,
                                            lg: 4,
                                            xl: 4,
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex gap-2 mb-3 mt-3",
                                                children: [
                                                    item.bus_doc_status != null && item.bus_doc_status > 0 ? /*#__PURE__*/ _jsx("div", {
                                                        children: /*#__PURE__*/ _jsx(StatusBankAndDoc, {
                                                            statusNo: item.bus_doc_status
                                                        })
                                                    }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        variant: "success",
                                                        onClick: function(e) {
                                                            setDataStatusDoc(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    idDoc: item.bus_doc_id,
                                                                    statusDoc: 3,
                                                                    commentDoc: "อนุมัติเอกสารแนบ " + item.bus_doc_typename
                                                                });
                                                            });
                                                            handleApproveDoc();
                                                        },
                                                        children: "อนุมัติ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        variant: "warning",
                                                        onClick: function(e) {
                                                            setDataStatusDoc(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    idDoc: item.bus_doc_id,
                                                                    statusDoc: 4,
                                                                    commentDoc: "ส่งกลับแก้ไขเอกสารแนบ " + item.bus_doc_typename
                                                                });
                                                            });
                                                            handleSendEditDoc();
                                                        },
                                                        children: "ส่งกลับแก้ไข"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                            /*#__PURE__*/ _jsx(Row, {
                                className: "align-items-center mb-3",
                                children: /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "secondary",
                                        onClick: function() {},
                                        className: "btn-st-3",
                                        disabled: props.formDisabled,
                                        children: "เพิ่มเอกสาร"
                                    })
                                })
                            })
                        ]
                    })
                }),
                partnerData.bus_business_status == 3 || partnerData.bus_business_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                    className: "justify-content-end",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: "auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-flex gap-2 mb-3 mt-3",
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "outline-secondary",
                                onClick: props.onBackPage,
                                children: "ย้อนกลับ"
                            })
                        })
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            ]
        })
    });
}
function CommentPartnerView(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var partnerId = useParams().partnerId;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState(""), 2), commentBox = _useState[0], setCommentBox = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), formdata = _useState2[0], setFormdata = _useState2[1];
    var loadAllMsts = function() {
        dispatch(getPartnerCommentById(parseInt(partnerId, 10), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getPartnerCommentByIdReducer = useAppSelector(function(state) {
        return state.getPartnerCommentByIdReducer;
    });
    var createCommentPartnerReducer = useAppSelector(function(state) {
        return state.createCommentPartnerReducer;
    });
    // useEffect(() => {
    //     loadAllMsts();
    // }, []);
    useEffect(function() {
        if (partnerId || props.redata) {
            loadAllMsts();
            props.setRedata(false);
        }
    }, [
        partnerId,
        props.redata
    ]);
    useEffect(function() {
        setIsLoading(getPartnerCommentByIdReducer.isFetching || createCommentPartnerReducer.isFetching);
        if (getPartnerCommentByIdReducer.data && !getPartnerCommentByIdReducer.isError) {
            var datas = getPartnerCommentByIdReducer.data.data;
            if (datas) {
                setFormdata(datas);
            }
        }
        if (isBoxAlert && createCommentPartnerReducer.data && !createCommentPartnerReducer.isError) {
            var updatedData = createCommentPartnerReducer.data.data;
            dispatch(clearCreateCommentPartner());
            if (isBoxAlert) {
                loadAllMsts();
                setIsBoxAlert(false);
            }
        }
    }, [
        getPartnerCommentByIdReducer,
        createCommentPartnerReducer
    ]);
    var handleChange = function(e) {
        setCommentBox(e.target.value);
    };
    var handleClick = function(val) {
        if (commentBox && commentBox.trim() !== "") {
            setIsLoading(true);
            var payload = {
                bus_comment_dtail: commentBox
            };
            dispatch(createCommentPartner(partnerId, payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            setCommentBox("");
        } else {
            setIsBoxAlert(false);
            setCommentBox("");
        }
    };
    return /*#__PURE__*/ _jsx(Card, {
        className: "card-st-3 mb-4",
        children: /*#__PURE__*/ _jsx(CardBody, {
            className: "px-2",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "pt-3 px-3",
                children: [
                    formdata && formdata.length > 0 ? formdata.map(function(item, index) {
                        return item.bus_comment_memid && item.bus_comment_memid > 0 ? /*#__PURE__*/ _jsxs(Row, {
                            className: "gx-xl-2 mb-3",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 2,
                                    md: 1,
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        className: "ms-auto",
                                        src: "/images/Avatar.png",
                                        roundedCircle: true,
                                        style: {
                                            width: 50,
                                            border: "4px solid #107BEF",
                                            borderRadius: 30
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 8,
                                    md: 10,
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-st-1 mx-3 p-3",
                                        style: {
                                            background: "#EFF2FC"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "horizontal",
                                                spacing: 3,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-6 fs-18",
                                                        children: item.MbMem.mb_mem_fullname && item.MbMem.mb_mem_fullname != "" && item.MbMem.mb_mem_fullname != null ? "คุณ " + item.MbMem.mb_mem_fullname : "Partner_" + item.bus_comment_memid
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-12 ms-auto",
                                                        children: item.bus_comment_credate && item.bus_comment_credate != "" && item.bus_comment_credate != null ? moment(item.bus_comment_credate).locale("th").format("D MMMM y H:mm") : "ไม่ระบุ"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 mt-1",
                                                children: item.bus_comment_dtail && item.bus_comment_dtail != "" && item.bus_comment_dtail != null ? item.bus_comment_dtail : "-"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, index) : /*#__PURE__*/ _jsxs(Row, {
                            className: "gx-xl-2 mb-3",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: {
                                        span: 8,
                                        offset: 2
                                    },
                                    md: {
                                        span: 10,
                                        offset: 1
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-st-1 mx-3 p-3",
                                        style: {
                                            background: "#F6E1E3"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "horizontal",
                                                spacing: 3,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-6 fs-18",
                                                        children: item.SysUser && item.SysUser.sys_user_fullname && item.SysUser.sys_user_fullname != "" && item.SysUser.sys_user_fullname != null ? item.SysUser.sys_user_fullname : "SYSTEM"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-12 ms-auto",
                                                        children: item.bus_comment_credate && item.bus_comment_credate != "" && item.bus_comment_credate != null ? moment(item.bus_comment_credate).locale("th").format("D MMMM y H:mm") : "ไม่ระบุ"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16 mt-1",
                                                children: item.bus_comment_dtail && item.bus_comment_dtail != "" && item.bus_comment_dtail != null ? item.bus_comment_dtail : "-"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 2,
                                    md: 1,
                                    children: item.bus_comment_crebyid && item.bus_comment_crebyid > 0 ? /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/avatar_admin.png",
                                        roundedCircle: true,
                                        style: {
                                            width: 50,
                                            border: "4px solid #107BEF",
                                            borderRadius: 30
                                        }
                                    }) : /*#__PURE__*/ _jsx(Avatar, {
                                        sx: {
                                            bgcolor: "rgba(244,64,54,1)",
                                            width: 50,
                                            height: 50
                                        },
                                        children: "S"
                                    })
                                })
                            ]
                        }, index);
                    }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                    /*#__PURE__*/ _jsxs(Row, {
                        className: "gx-xl-2",
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 2,
                                md: 1,
                                className: "pr-2",
                                children: /*#__PURE__*/ _jsx(Stack, {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    spacing: 2,
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        className: "ms-auto",
                                        src: "/images/avatar_admin.png",
                                        roundedCircle: true,
                                        style: {
                                            width: 50,
                                            border: "4px solid #107BEF",
                                            borderRadius: 30
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 10,
                                md: 11,
                                className: "pl-0",
                                children: /*#__PURE__*/ _jsxs(InputGroup, {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "text",
                                            placeholder: "เพิ่มคอมเมนต์",
                                            "aria-label": "Recipient's username",
                                            "aria-describedby": "basic-addon2",
                                            onChange: handleChange,
                                            value: commentBox
                                        }),
                                        /*#__PURE__*/ _jsx(InputGroup.Text, {
                                            id: "basic-addon2",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                className: "btn-dg fs-10",
                                                onClick: handleClick,
                                                children: "คอมเมนต์"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function StatusPartner(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    var statusNo = props.statusNo;
    return statusNo === 5 ? /*#__PURE__*/ _jsx("span", {
        className: "px-3 py-2 text-center badge",
        style: {
            color: "rgba(211, 47, 47, 1)",
            backgroundColor: "rgba(253, 237, 237, 1)",
            borderRadius: "20px"
        },
        children: "ไม่อนุมัติ"
    }) : statusNo === 4 ? /*#__PURE__*/ _jsx("span", {
        className: "px-3 py-2 text-center badge",
        style: {
            color: "#6f42c1",
            backgroundColor: "#e2d9f3",
            borderRadius: "20px"
        },
        children: "รอแก้ไข"
    }) : statusNo === 3 ? /*#__PURE__*/ _jsx("span", {
        className: "px-3 py-2 text-center badge",
        style: {
            color: "rgba(114, 225, 40, 0.87)",
            backgroundColor: "rgba(238, 251, 229, 1)",
            borderRadius: "20px"
        },
        children: "อนุมัติ"
    }) : statusNo === 2 ? /*#__PURE__*/ _jsx("span", {
        className: "px-3 py-2 text-center badge",
        style: {
            color: "rgba(253, 180, 40, 1)",
            backgroundColor: "rgba(255, 246, 229, 1)",
            borderRadius: "20px"
        },
        children: "รออนุมัติ"
    }) : /*#__PURE__*/ _jsx("span", {
        className: "px-3 py-2 text-center badge",
        style: {
            color: "rgba(116, 116, 116, 1)",
            backgroundColor: "rgba(244, 244, 244, 1)",
            borderRadius: "20px"
        },
        children: "แบบร่าง"
    });
}
function StatusBankAndDoc(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    var statusNo = props.statusNo;
    return statusNo === 5 ? /*#__PURE__*/ _jsxs("span", {
        className: "px-3 py-2 text-center badge fs-16",
        style: {
            color: "rgba(211, 47, 47, 1)",
            backgroundColor: "rgba(253, 237, 237, 1)",
            borderRadius: "20px",
            width: "150px"
        },
        children: [
            /*#__PURE__*/ _jsx(CancelIcon, {
                className: "mr-1"
            }),
            "ไม่อนุมัติ"
        ]
    }) : statusNo === 4 ? /*#__PURE__*/ _jsxs("span", {
        className: "px-3 py-2 text-center badge fs-16",
        style: {
            color: "#6f42c1",
            backgroundColor: "#e2d9f3",
            borderRadius: "20px",
            width: "150px"
        },
        children: [
            /*#__PURE__*/ _jsx(ReplyAllIcon, {
                className: "mr-1"
            }),
            "ส่งกลับแก้ไข"
        ]
    }) : statusNo === 3 ? /*#__PURE__*/ _jsxs("span", {
        className: "px-3 py-2 text-center badge fs-16",
        style: {
            color: "rgba(25, 135, 84, 1)",
            backgroundColor: "rgba(238, 251, 229, 1)",
            borderRadius: "20px",
            width: "150px"
        },
        children: [
            /*#__PURE__*/ _jsx(CheckCircleIcon, {
                className: "mr-1"
            }),
            "ตรวจสอบแล้ว"
        ]
    }) : statusNo === 2 ? /*#__PURE__*/ _jsxs("span", {
        className: "px-3 py-2 text-center badge fs-16",
        style: {
            color: "rgba(253, 180, 40, 1)",
            backgroundColor: "rgba(255, 246, 229, 1)",
            borderRadius: "20px",
            width: "150px"
        },
        children: [
            /*#__PURE__*/ _jsx(ErrorIcon, {
                className: "mr-1"
            }),
            "รอตรวจสอบ"
        ]
    }) : /*#__PURE__*/ _jsxs("span", {
        className: "px-3 py-2 text-center badge fs-16",
        style: {
            color: "rgba(116, 116, 116, 1)",
            backgroundColor: "rgba(244, 244, 244, 1)",
            borderRadius: "20px",
            width: "150px"
        },
        children: [
            /*#__PURE__*/ _jsx(InsertDriveFileIcon, {
                className: "mr-1"
            }),
            "แบบร่าง"
        ]
    });
}
function ApproveBankModal(_param) {
    var approveBank = _param.approveBank, setApproveBank = _param.setApproveBank, modalsuccess = _param.modalsuccess, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "approveBank",
        "setApproveBank",
        "modalsuccess",
        "setModalsuccess"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var updateStatusBankPartnerReducer = useAppSelector(function(state) {
        return state.updateStatusBankPartnerReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        console.log("approveBank :", approveBank);
        setIsLoading(true);
        var payload = {
            status: 3,
            comment: approveBank.comment
        };
        dispatch(updateStatusBankPartner(approveBank.idBank, payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setIsBoxAlert(true);
        props.onHide();
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusBankPartnerReducer.isFetching);
        if (updateStatusBankPartnerReducer.data && !updateStatusBankPartnerReducer.isError) {
            var updatedData = updateStatusBankPartnerReducer.data.data;
            dispatch(clearUpdateStatusBankPartner());
            if (isBoxAlert) {
                setModalsuccess(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "อนุมัติเรียบร้อย",
                        direction: ""
                    });
                });
                props.redata();
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusBankPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "อนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Badge, {
                    bg: "danger-light",
                    text: "dark",
                    children: [
                        /*#__PURE__*/ _jsx(InfoIcon, {
                            sx: {
                                color: "#B00412"
                            },
                            className: "mr-2"
                        }),
                        "คุณต้องการที่จะอนุมัติข้อมูลธนาคารนี้หรือไม่"
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function SendEditBankModal(_param) {
    var sendEditBank = _param.sendEditBank, setSendEditBank = _param.setSendEditBank, modalsuccess = _param.modalsuccess, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "sendEditBank",
        "setSendEditBank",
        "modalsuccess",
        "setModalsuccess"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), remark = _useState[0], setRemark = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var updateStatusBankPartnerReducer = useAppSelector(function(state) {
        return state.updateStatusBankPartnerReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function() {
        console.log("sendEditBank : ", sendEditBank);
        if (remark && remark.trim() !== "") {
            setIsLoading(true);
            var payload = {
                status: 4,
                comment: remark
            };
            dispatch(updateStatusBankPartner(sendEditBank.idBank, payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            setRemark("");
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการแก้ไข"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusBankPartnerReducer.isFetching);
        if (updateStatusBankPartnerReducer.data && !updateStatusBankPartnerReducer.isError) {
            var updatedData = updateStatusBankPartnerReducer.data.data;
            dispatch(clearUpdateStatusBankPartner());
            if (isBoxAlert) {
                setModalsuccess(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "ส่งกลับไปให้แก้ไขเรียบร้อย",
                        direction: ""
                    });
                });
                props.redata();
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusBankPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ส่งกลับไปแก้ไขข้อมูลธนาคาร"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center mt-3",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการแก้ไข ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-red-gb",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "remark_partner_bank",
                                    placeholder: "กรอกคำอธิบาย",
                                    style: {
                                        resize: "none"
                                    },
                                    onChange: handleChange
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function ApproveDocModal(_param) {
    var approveDoc = _param.approveDoc, setApproveDoc = _param.setApproveDoc, modalsuccess = _param.modalsuccess, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "approveDoc",
        "setApproveDoc",
        "modalsuccess",
        "setModalsuccess"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var updateStatusDocPartnerReducer = useAppSelector(function(state) {
        return state.updateStatusDocPartnerReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        console.log("approveDoc :", approveDoc);
        setIsLoading(true);
        var payload = {
            status: 3,
            comment: approveDoc.commentDoc
        };
        dispatch(updateStatusDocPartner(approveDoc.idDoc, payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setIsBoxAlert(true);
        props.onHide();
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusDocPartnerReducer.isFetching);
        if (updateStatusDocPartnerReducer.data && !updateStatusDocPartnerReducer.isError) {
            var updatedData = updateStatusDocPartnerReducer.data.data;
            dispatch(clearUpdateStatusDocPartner());
            if (isBoxAlert) {
                setModalsuccess(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "อนุมัติเรียบร้อย",
                        direction: ""
                    });
                });
                props.redata();
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusDocPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "อนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Badge, {
                    bg: "danger-light",
                    text: "dark",
                    children: [
                        /*#__PURE__*/ _jsx(InfoIcon, {
                            sx: {
                                color: "#B00412"
                            },
                            className: "mr-2"
                        }),
                        "คุณต้องการที่จะอนุมัติเอกสารแนบนี้หรือไม่"
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function SendEditDocModal(_param) {
    var sendEditDoc = _param.sendEditDoc, setSendEditDoc = _param.setSendEditDoc, modalsuccess = _param.modalsuccess, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "sendEditDoc",
        "setSendEditDoc",
        "modalsuccess",
        "setModalsuccess"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), remark = _useState[0], setRemark = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var updateStatusDocPartnerReducer = useAppSelector(function(state) {
        return state.updateStatusDocPartnerReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function() {
        console.log("sendEditDoc : ", sendEditDoc);
        if (remark && remark.trim() !== "") {
            setIsLoading(true);
            var payload = {
                status: 4,
                comment: remark
            };
            dispatch(updateStatusDocPartner(sendEditDoc.idDoc, payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            setRemark("");
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการแก้ไข"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusDocPartnerReducer.isFetching);
        if (updateStatusDocPartnerReducer.data && !updateStatusDocPartnerReducer.isError) {
            var updatedData = updateStatusDocPartnerReducer.data.data;
            dispatch(clearUpdateStatusDocPartner());
            if (isBoxAlert) {
                setModalsuccess(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "ส่งกลับไปให้แก้ไขเรียบร้อย",
                        direction: ""
                    });
                });
                props.redata();
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusDocPartnerReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ส่งกลับไปแก้ไขข้อมูลธนาคาร"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center mt-3",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการแก้ไข ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-red-gb",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "remark_partner_bank",
                                    placeholder: "กรอกคำอธิบาย",
                                    style: {
                                        resize: "none"
                                    },
                                    onChange: handleChange
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
